import { ApolloError, FetchPolicy, useQuery } from '@apollo/client';
import { ParsedUrlQuery } from 'querystring';

import { FindHierarchicalLocationBySlugResponse } from 'src/modules/Opportunities/pages/Explore/types';
import { HierarchicalLocation } from 'src/modules/Profile/graphql/hierarchicalLocations';

import { findHierarchicalLocationsBySlug } from '../graphql';
import {
  getFilterSlugValueFromQuery,
  getLocationFromResponse,
} from '../helpers';

export interface FindHierarchicalLocationBySlugResult {
  hierarchicalLocation?: HierarchicalLocation;
  loading: boolean;
  error?: ApolloError;
}

/**
 * This hook is used for InternSearchQueryPage
 * It aims to get location (locationId and locationName) from slug
 * @param query
 */
export const useGetHierarchicalLocationsBySlug = (
  query: ParsedUrlQuery
): FindHierarchicalLocationBySlugResult => {
  const { slug, isLocationSlug } = getFilterSlugValueFromQuery(query);
  const queryOptions = {
    variables: {
      slug,
    },
    fetchPolicy: 'cache-first' as FetchPolicy,
    skip: !slug || !isLocationSlug,
  };

  const { data, loading, error } =
    useQuery<FindHierarchicalLocationBySlugResponse>(
      findHierarchicalLocationsBySlug,
      queryOptions
    );

  if (error) {
    console.error(
      'QueryExplorePageError fetching hierarchical location by slug:',
      error
    );
  }

  return {
    hierarchicalLocation: getLocationFromResponse(data),
    loading,
    error,
  };
};
